var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPagePreview = void 0;
const contentful = __importStar(require("contentful"));
const content_model_by_ids_1 = require("./content-model-by-ids");
const firstUpperCase = (str) => str.charAt(0).toUpperCase() + str.slice(1);
const reportMissingType = (name, value, contentType, cfField) => {
    console.log(`Error: missing '${name}' with value '${value}'`, contentType, cfField);
};
exports.createPagePreview = (context) => {
    const pagePreview = {
        getGatbsyFields() {
            return __awaiter(this, void 0, void 0, function* () {
                yield this._fetch();
                if (!this._cfEntry) {
                    return;
                }
                const gatsbyFields = this._processCfEntry(this._cfEntry, 0);
                return gatsbyFields;
            });
        },
        _fetch() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!(this._cfConfig.accessToken && this._cfConfig.space)) {
                    console.error(`Could not initialize Contentful client:
    AccessToken: ${this._cfConfig.accessToken}
    Space; ${this._cfConfig.space}`);
                    return;
                }
                if (this._cfConfig.accessToken && this._cfConfig.space) {
                    if (!context.entryId) {
                        console.log('Warning: no entryId found, getting the first entry avaiable');
                    }
                    try {
                        this._client = contentful.createClient(this._cfConfig);
                        const query = {
                            'sys.id': context.entryId,
                            include: this._include || 5,
                        };
                        if (context.locale) {
                            query.locale = context.locale;
                        }
                        const entries = yield this._client.getEntries(query);
                        this._cfEntry = entries.items[0];
                        const contentTypeId = this._cfEntry.sys.contentType.sys.id;
                        const contentTypes = yield this._client.getContentTypes(contentTypeId);
                        this._contentModel = content_model_by_ids_1.contentModelByIds(contentTypes);
                    }
                    catch (error) {
                        console.log(`Could not fetch ${context.entryId}: ${error.message}`);
                    }
                }
            });
        },
        _processCfEntry(cfEntry, level) {
            const resovedEntry = {};
            const maxDepth = this._maxDepth || 5;
            if (level > maxDepth) {
                return;
            }
            if (!(typeof cfEntry === 'object' && 'fields' in cfEntry)) {
                return;
            }
            const contentTypeId = cfEntry.sys.contentType.sys.id;
            resovedEntry.__typename = this._PREFIX + firstUpperCase(contentTypeId);
            Object.entries(cfEntry.fields).forEach(([fieldName, cfFieldValue]) => {
                resovedEntry[fieldName] = this._processCfField(contentTypeId, fieldName, cfFieldValue, level);
            });
            return resovedEntry;
        },
        _processCfField(contentTypeId, fieldName, cfField, level) {
            const contentType = this._contentModel[contentTypeId][fieldName];
            switch (contentType.type) {
                case 'Array':
                    switch (contentType.items.type) {
                        case 'Link':
                            const gatsbyArray = [];
                            cfField.forEach((entry) => {
                                const gEntry = this._processCfEntry(entry, level + 1);
                                if (gEntry) {
                                    gatsbyArray.push(gEntry);
                                }
                            });
                            return gatsbyArray;
                            break;
                        case 'Symbol':
                            return cfField;
                            break;
                        default:
                            reportMissingType('Array/items.type', contentType.items.type, contentType, cfField);
                            break;
                    }
                case 'Date':
                case 'Integer':
                case 'Symbol':
                    return cfField;
                    break;
                case 'RichText':
                    return { json: cfField };
                    break;
                case 'Text':
                    return { [fieldName]: cfField };
                case 'Link':
                    switch (contentType.linkType) {
                        case 'Entry':
                            return this._processCfEntry(cfField, level + 1);
                            break;
                        case 'Asset':
                            const file = (cfField.fields && cfField.fields.file) || {
                                url: '//placehold.it/512',
                                fileName: 'no-name',
                                contentType: 'image/jpeg',
                            };
                            return {
                                description: cfField.fields && cfField.fields.description,
                                title: cfField.fields && cfField.fields.title,
                                file,
                                fluid: {
                                    sizes: '(max-width: 1024px) 100vw, 1024px',
                                    src: file.url + '?w=1024&q=50',
                                    srcSet: file.url +
                                        '?w=256&h=256&q=50 256w,\n' +
                                        file.url +
                                        '?w=512&h=512&q=50 512w,\n' +
                                        file.url +
                                        '?w=1024&h=1023&q=50 1024w,\n' +
                                        file.url +
                                        '?w=1026&h=1025&q=50 1026w',
                                },
                            };
                            break;
                        default:
                            reportMissingType('Link/linkType', contentType.linkType, contentType, cfField);
                            break;
                    }
                default:
                    reportMissingType('type', contentType.type, contentType, cfField);
                    break;
            }
        },
        _include: context.include,
        _maxDepth: context.maxDepth,
        _PREFIX: 'Contentful',
        _cfConfig: {
            accessToken: context.previewSecrets.previewToken,
            host: 'preview.contentful.com',
            space: context.previewSecrets.spaceId,
        },
        _contentModel: {},
    };
    if (context.previewSecrets.environment) {
        pagePreview._cfConfig.environment = context.previewSecrets.environment;
    }
    return pagePreview;
};
//# sourceMappingURL=create-page-preview.js.map